var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.897 12.9026C14.695 14.7023 20.0011 20 20.0011 20C20.0011 20 27.604 12.4084 27.6905 12.313H27.6917C28.5001 11.4302 29 10.2169 29 8.87623C29 6.18249 26.9857 4 24.5 4C22.0143 4 20 6.18249 20 8.87623C20 9.0103 20 9.0103 20 8.87623C20 6.18249 17.9857 4 15.5 4C13.0143 4 11 6.18249 11 8.87623C11 10.0498 11.3826 11.1258 12.0202 11.9665",
    fill: "#F5FBFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.87623C20 6.18249 22.0143 4 24.5 4C26.9857 4 29 6.18249 29 8.87623C29 10.2169 28.5001 11.4302 27.6917 12.313H27.6905C27.604 12.4084 20.0011 20 20.0011 20C20.0011 20 14.695 14.7023 12.897 12.9026L12.0202 11.9665C11.3826 11.1258 11 10.0498 11 8.87623C11 6.18249 13.0143 4 15.5 4C17.9857 4 20 6.18249 20 8.87623ZM20 8.87623C20 9.0103 20 9.0103 20 8.87623Z",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45312 36H6.92969L6.94531 33.8906H9.45312C9.97396 33.8906 10.4141 33.7656 10.7734 33.5156C11.138 33.2656 11.4141 32.8932 11.6016 32.3984C11.7943 31.8984 11.8906 31.2839 11.8906 30.5547V30.0625C11.8906 29.5156 11.8359 29.0365 11.7266 28.625C11.6224 28.2083 11.4661 27.862 11.2578 27.5859C11.0495 27.3047 10.7891 27.0938 10.4766 26.9531C10.1693 26.8125 9.8151 26.7422 9.41406 26.7422H6.88281V24.625H9.41406C10.1849 24.625 10.8906 24.7578 11.5312 25.0234C12.1771 25.2839 12.7344 25.6589 13.2031 26.1484C13.6771 26.6328 14.0417 27.2083 14.2969 27.875C14.5573 28.5365 14.6875 29.2708 14.6875 30.0781V30.5547C14.6875 31.3568 14.5573 32.0911 14.2969 32.7578C14.0417 33.4245 13.6797 34 13.2109 34.4844C12.7422 34.9688 12.1875 35.3438 11.5469 35.6094C10.9115 35.8698 10.2135 36 9.45312 36ZM8.5 24.625V36H5.75781V24.625H8.5ZM23.9453 33.8906V36H17.8828V33.8906H23.9453ZM18.8594 24.625V36H16.1172V24.625H18.8594ZM23.1641 29.1406V31.1797H17.8828V29.1406H23.1641ZM23.9688 24.625V26.7422H17.8828V24.625H23.9688ZM29.8906 27.0156L27.1172 36H24.1719L28.3516 24.625H30.2188L29.8906 27.0156ZM32.1875 36L29.4062 27.0156L29.0469 24.625H30.9375L35.1406 36H32.1875ZM32.0781 31.7578V33.875H26.2422V31.7578H32.0781Z",
    fill: "#228C80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 7.4994C33 9.43305 31.433 11.0001 29.4994 11.0001C27.5657 11.0001 26 9.43305 26 7.4994C26 5.56575 27.567 4 29.4994 4C31.4317 4 33 5.56701 33 7.4994Z",
    fill: "#F9839A",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4996 6V9.00003",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31 7.50043H28",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDea);
export default __webpack_public_path__ + "static/media/Ic_DEA.a83395248bbc08cb69f5731800307fc0.svg";
export { ForwardRef as ReactComponent };